// @flow
import createCss from './createCss'
import type {Css, Style} from './types'

export type {Css, Style}
export {createCss as create}
export default createCss()
